import t from "./ghl-ui.es771.js";
import d from "./ghl-ui.es1482.js";
import g from "./ghl-ui.es1473.js";
import a from "./ghl-ui.es1483.js";
import M from "./ghl-ui.es403.js";
import v from "./ghl-ui.es788.js";
import x from "./ghl-ui.es1484.js";
function D(f, r, e, n, i) {
  f !== r && g(r, function(o, m) {
    if (i || (i = new t()), M(o))
      a(f, r, m, e, D, n, i);
    else {
      var p = n ? n(x(f, m), o, m + "", f, r, i) : void 0;
      p === void 0 && (p = o), d(f, m, p);
    }
  }, v);
}
export {
  D as default
};
